import { IRiderPortalState } from 'src/types/rider-portal-state'
import { IRiderPortalActions } from 'src/state/actions/rider-portal/main'
import * as constants from 'src/state/constants'

const initState: IRiderPortalState = {
  loading: {
    fetchingProducts: false,
    fetchingServices: false,
    fetchingSavedLocations: false,
    fetchingTripDetails: false,
    requestingTripBooking: false,
    updatingTrip: false,
    isLoading: false,
    fetchingTripsHistory: false
  },
  availableProducts: [],
  availableServices: [],
  designatedServiceZones: {},
  loggedInRiderDetails: {},
  savedLocations: [],
  serviceZones: {},
  trips: {
    currentlyViewedTrips: {},
    // userAllTripRecords: []
    riderTripsHistory: [],
    filters: {
      orgId: '05834112-5a3b-4109-8df6-390df5628726',
      riderId: [],
      skip: 0,
      sortBy: ['-createdAt'],
      status: [],
      take: 25,
      timeEnd: '',
      timeStart: '',
      timeField: 'createdAt'
    }
  }
}

export function riderPortal(state: IRiderPortalState = initState, action: IRiderPortalActions): IRiderPortalState {
  switch (action.type) {
    case constants.RESET_CURRENTLY_VIEWED_TRIPS: {
      return Object.assign({}, state, { trips: { ...state.trips, currentlyViewedTrips: {} } })
    }
    case constants.SET_LOADING_METADATA: {
      const { type, status } = action.payload
      return Object.assign({}, state, { loading: { ...state.loading, [type]: status } })
    }
    case constants.SET_AVAILABLE_PRODUCTS: {
      return Object.assign({}, state, { availableProducts: action.payload })
    }
    case constants.SET_AVAILABLE_SERVICE_BY_CURRENT_LOCATION: {
      return Object.assign({}, state, { availableServices: action.payload })
    }
    case constants.SET_RIDER_SAVED_LOCATIONS: {
      return Object.assign({}, state, { savedLocations: action.payload })
    }
    case constants.SET_SERVICE_DESIGNATED_ZONES: {
      return Object.assign({}, state, {
        designatedServiceZones: { ...state.designatedServiceZones, ...action.payload }
      })
    }
    case constants.SET_SERVICE_ZONES: {
      return Object.assign({}, state, { serviceZones: { ...state.serviceZones, ...action.payload } })
    }
    case constants.SET_CURRENTLY_VIEWED_TRIPS: {
      return Object.assign({}, state, { trips: { ...state.trips, currentlyViewedTrips: action.payload } })
    }
    case constants.SET_LOGGED_IN_RIDER_DETAILS: {
      return Object.assign({}, state, { loggedInRiderDetails: action.payload })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/rider-portal/index.ts